import * as React from "react";

import { RLink } from "../DesignSystem/RLink";

export const RegisterOrLoginPrompt = ({ doWhat }: { doWhat: string }) => {
  return (
    <div>
      You should{" "}
      <RLink className="darklink-notzelda" to="/register">
        register an account
      </RLink>{" "}
      or{" "}
      <RLink className="darklink-notzelda" to="/login">
        login
      </RLink>{" "}
      to {doWhat}!
    </div>
  );
};
